import { OktaAuthClient } from "../auth/okta";
import { FeedbackData } from "./types/models";
import { ERROR_MESSAGES } from "../constants";

export const API_HOST = import.meta.env.VITE_API_HOST ?? "";

export async function feedbackApi(request: { id: string; feedback: FeedbackData }): Promise<Response> {
  return await post("/save/feedback", request);
}

const removeDoubleSlashes = (url: string): string => {
  let cleanedUrl = url;
  while (cleanedUrl.includes("//")) {
    cleanedUrl = cleanedUrl.replace("//", "/");
  }
  return cleanedUrl;
};

async function post<T>(url: string, data: T): Promise<Response> {
  return callAPI(url, data, "POST");
}

export async function callAPI<T>(
  url: string,
  data: T | null = null,
  method: "POST" | "DELETE" | "PUT" | "GET" = "POST",
  customHost?: string
): Promise<Response> {
  const isAuthenticated = await OktaAuthClient.isAuthenticated();
  if (!isAuthenticated) {
    throw new Error(ERROR_MESSAGES.NOT_AUTHENTICATED);
  }

  const apiHost = customHost || API_HOST;

  const response = await fetch(apiHost + removeDoubleSlashes(url), {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${OktaAuthClient.getAccessToken()}`
    },
    body: data ? JSON.stringify(data) : undefined
  });

  if (!response.ok) {
    throw new Error(`${ERROR_MESSAGES.HTTP_ERROR} ${response.status}`);
  }

  return response;
}
